export default "__VITE_ASSET__Dka2pbZT__"